import branding from "./branding";

import verifyOverridesEn from "./locales/en/verify.json";
import verifyOverridesPt from "./locales/pt/verify.json";
import publicPortalOverridesEn from "./locales/en/publicPortal.json";
import publicPortalOverridesPt from "./locales/pt/publicPortal.json";

const stp = {
  id: "stp",
  branding,
  localeOverrides: {
    en: { verify: verifyOverridesEn, publicPortal: publicPortalOverridesEn },
    pt: { verify: verifyOverridesPt, publicPortal: publicPortalOverridesPt },
  },
};

export default stp;
